// Formats an ISO 'YYYY-MM-DD' date string (exactly what the backend's
// date.isoformat() sends, with no time component) as 'DD-MM-YY'. Plain
// string-split rather than the Date object - a date-only ISO string
// parsed via `new Date(...)` gets interpreted as UTC midnight and can
// shift a day in either direction depending on the viewer's timezone,
// which is exactly wrong for a value that's meant to be timezone-less.
export const formatDateDDMMYY = (isoDate) => {
  if (!isoDate) return isoDate;
  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) return isoDate;
  return `${day}-${month}-${year.slice(-2)}`;
};
